import '../__generated__/styles/radio.css';
import _extends from '@babel/runtime/helpers/esm/extends';
import _defineProperty from '@babel/runtime/helpers/esm/defineProperty';
import _objectWithoutProperties from '@babel/runtime/helpers/esm/objectWithoutProperties';
import React, { forwardRef } from 'react';
import clsx from 'clsx';
import { useTheme } from '@swift-paypal/pp-react-theme';
import { V2CriticalIcon, CriticalAltIcon } from '@swift-paypal/pp-react-icons';

var styles = {"ppvx_radio-group":"ppvx_radio-group___2-9-10","ppvx_radio":"ppvx_radio___2-9-10","ppvx_radio__input":"ppvx_radio__input___2-9-10","ppvx_radio__label":"ppvx_radio__label___2-9-10","ppvx_radio__label--with-svg-icon":"ppvx_radio__label--with-svg-icon___2-9-10","ppvx_radio__check-icon-container":"ppvx_radio__check-icon-container___2-9-10","ppvx_radio__label--centered":"ppvx_radio__label--centered___2-9-10","ppvx_radio__check-icon":"ppvx_radio__check-icon___2-9-10","ppvx_icon":"ppvx_icon___2-9-10","ppvx_radio__label-icon":"ppvx_radio__label-icon___2-9-10","ppvx_field--error":"ppvx_field--error___2-9-10","ppvx_radio-group__label":"ppvx_radio-group__label___2-9-10","ppvx_radio__helper-text":"ppvx_radio__helper-text___2-9-10","ppvx_radio-group__helper-text":"ppvx_radio-group__helper-text___2-9-10","ppvx_radio-group__error-text":"ppvx_radio-group__error-text___2-9-10","ppvx_radio-group__error-icon":"ppvx_radio-group__error-icon___2-9-10","ppvx_radio-group__error-text--with-svg-icon":"ppvx_radio-group__error-text--with-svg-icon___2-9-10","ppvx--v2":"ppvx--v2___2-9-10","ppvx--v1":"ppvx--v1___2-9-10"};

var renderHelperText = function (text) {
  return text && /*#__PURE__*/React.createElement("p", {
    className: styles['ppvx_radio__helper-text']
  }, text);
};

var inferValue = function (label) {
  if (typeof label === 'string') {
    return label;
  }

  return 'value_not_set';
};

var RadioCheckIcon = function () {
  return /*#__PURE__*/React.createElement("span", {
    className: styles['ppvx_radio__check-icon']
  }, /*#__PURE__*/React.createElement("svg", {
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("circle", {
    r: "18",
    id: "svg_1",
    cy: "50",
    cx: "50",
    strokeWidth: "0",
    fill: "currentColor"
  })));
};

var generatedName = function () {
  return "".concat(Math.random().toFixed(8).toString().replace('0.', ''));
};

var Radio = forwardRef(function (_ref, ref) {
  var label = _ref.label,
      labelIcon = _ref.labelIcon,
      _ref$name = _ref.name,
      name = _ref$name === void 0 ? generatedName() : _ref$name,
      _ref$value = _ref.value,
      value = _ref$value === void 0 ? inferValue(label) : _ref$value,
      _ref$id = _ref.id,
      id = _ref$id === void 0 ? "Radio_".concat(name, "_").concat(value) : _ref$id,
      _ref$centeredLabel = _ref.centeredLabel,
      centeredLabel = _ref$centeredLabel === void 0 ? false : _ref$centeredLabel,
      helperText = _ref.helperText,
      className = _ref.className,
      labelClassName = _ref.labelClassName,
      onChange = _ref.onChange,
      _ref$checked = _ref.checked,
      checked = _ref$checked === void 0 ? false : _ref$checked,
      rest = _objectWithoutProperties(_ref, ["label", "labelIcon", "name", "value", "id", "centeredLabel", "helperText", "className", "labelClassName", "onChange", "checked"]);

  var checkedPropName = onChange ? 'checked' : 'defaultChecked';
  var valueProps = {
    onChange: onChange
  };
  valueProps[checkedPropName] = checked;
  var labelIconElm = labelIcon && /*#__PURE__*/React.createElement("span", {
    className: styles['ppvx_radio__label-icon']
  }, labelIcon);
  var labelClasses = clsx(styles.ppvx_radio__label, styles['ppvx_radio__label--with-svg-icon'], _defineProperty({}, styles["ppvx_radio__label--centered"], centeredLabel), labelClassName);
  return /*#__PURE__*/React.createElement("div", {
    className: clsx(styles.ppvx_radio, className)
  }, /*#__PURE__*/React.createElement("input", _extends({
    className: styles.ppvx_radio__input,
    type: "radio",
    name: name,
    value: value,
    id: id,
    ref: ref
  }, valueProps, rest)), /*#__PURE__*/React.createElement("label", {
    className: labelClasses,
    htmlFor: id
  }, /*#__PURE__*/React.createElement("span", {
    className: styles['ppvx_radio__check-icon-container']
  }, /*#__PURE__*/React.createElement(RadioCheckIcon, null)), label, labelIconElm, renderHelperText(helperText)));
});

var generatedName$1 = "RadioGroup_".concat(Math.random().toFixed(8).toString().replace('0.', ''));

var RadioGroup = function (_ref) {
  var _clsx;

  var _ref$name = _ref.name,
      name = _ref$name === void 0 ? generatedName$1 : _ref$name,
      label = _ref.label,
      labelIcon = _ref.labelIcon,
      helperText = _ref.helperText,
      errorText = _ref.errorText,
      error = _ref.error,
      children = _ref.children;
  var message = (errorText || helperText) && /*#__PURE__*/React.createElement("label", {
    className: clsx((_clsx = {}, _defineProperty(_clsx, styles['ppvx_radio-group__helper-text'], !error), _defineProperty(_clsx, styles['ppvx_radio-group__error-text'], error), _clsx))
  }, error ? errorText : helperText);
  var labelIconElm = labelIcon && /*#__PURE__*/React.createElement("span", {
    className: styles['ppvx_radio__label-icon']
  }, labelIcon);
  return /*#__PURE__*/React.createElement("fieldset", {
    className: clsx(styles['ppvx_radio-group'], _defineProperty({}, styles['ppvx_field--error'], error))
  }, /*#__PURE__*/React.createElement("legend", {
    className: styles['ppvx_radio-group__label']
  }, label, labelIconElm), children && // @ts-ignore
  React.Children.map(children, function (radio, index) {
    var _radio$props = radio.props,
        _radio$props$value = _radio$props.value,
        value = _radio$props$value === void 0 ? '' + index : _radio$props$value,
        newProps = _objectWithoutProperties(_radio$props, ["value"]);

    return /*#__PURE__*/React.createElement(Radio, _extends({
      key: index,
      name: name,
      value: value
    }, newProps));
  }), message);
};

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var FieldGroupLabel = function (_ref) {
  var _ref$as = _ref.as,
      as = _ref$as === void 0 ? 'legend' : _ref$as,
      children = _ref.children,
      className = _ref.className,
      icon = _ref.icon,
      rest = _objectWithoutProperties(_ref, ["as", "children", "className", "icon"]);

  return React.createElement(as, _objectSpread({
    className: clsx(className, styles['ppvx_radio-group__label'], styles['ppvx_radio-group__label--with-svg-icon'])
  }, rest), children, icon);
};

var FieldGroupMessage = function (_ref) {
  var errorText = _ref.errorText,
      helperText = _ref.helperText,
      msgId = _ref.msgId,
      theme = _ref.theme;
  // Get either the error message or helper text or... nothing
  var radioErrorIcon = theme === 'v2' ? /*#__PURE__*/React.createElement(V2CriticalIcon, {
    className: styles['ppvx_radio-group__error-icon'],
    size: "sm"
  }) : /*#__PURE__*/React.createElement(CriticalAltIcon, {
    className: styles['ppvx_radio-group__error-icon'],
    size: "xs"
  });
  return errorText && /*#__PURE__*/React.createElement("p", {
    className: clsx(styles['ppvx_radio-group__error-text'], styles['ppvx_radio-group__error-text--with-svg-icon']),
    id: msgId
  }, radioErrorIcon, errorText) || helperText && /*#__PURE__*/React.createElement("p", {
    className: styles['ppvx_radio-group__helper-text'],
    id: msgId
  }, helperText) || null;
};

function ownKeys$1(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$1(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$1(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$1(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/* istanbul ignore next */
var uniqueId = function (id) {
  var prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '_';
  return id === undefined ? "".concat(prefix).concat(Math.random().toFixed(8).toString().replace('0.', '')) : id;
};

var RadioButton = function (_ref) {
  var className = _ref.className,
      radioLabelClassName = _ref.radioLabelClassName,
      errorText = _ref.errorText,
      helperText = _ref.helperText,
      id = _ref.id,
      label = _ref.label,
      name = _ref.name,
      _ref$value = _ref.value,
      value = _ref$value === void 0 ? '' : _ref$value,
      icon = _ref.icon,
      options = _ref.options,
      onChange = _ref.onChange,
      theme = _ref.theme,
      rest = _objectWithoutProperties(_ref, ["className", "radioLabelClassName", "errorText", "helperText", "id", "label", "name", "value", "icon", "options", "onChange", "theme"]);

  var _theme = useTheme('RadioButton', theme);

  var radioId = "".concat(uniqueId(id, 'RadioButtton'));
  var msgId = "message_".concat(radioId);
  var containerClass = clsx(styles['ppvx_radio-group'], _defineProperty({}, styles['ppvx--v2'], _theme && _theme === 'v2'), className, _defineProperty({}, styles['ppvx_field--error'], !!errorText));
  return (
    /*#__PURE__*/
    //@ts-ignore
    React.createElement("fieldset", _extends({
      className: containerClass
    }, rest), /*#__PURE__*/React.createElement(FieldGroupLabel, {
      icon: icon
    }, label), function renderRadios(optionsList, componentName, currentValue, changeHandler) {
      if (optionsList.length === 0) {
        return /*#__PURE__*/React.createElement("i", null, "No Options!");
      }

      return optionsList.map(function (listProps, index) {
        var checkedPropName = changeHandler ? 'checked' : 'defaultChecked';

        var radioProps = _objectSpread$1(_objectSpread$1({}, listProps), {}, {
          labelClassName: radioLabelClassName
        });

        if (currentValue === listProps.value) {
          radioProps[checkedPropName] = true;
        }

        return /*#__PURE__*/React.createElement(Radio, _extends({
          key: "rbtn-item".concat(index),
          name: componentName,
          onChange: changeHandler
        }, radioProps, rest));
      });
    }(options, name, value, onChange), /*#__PURE__*/React.createElement(FieldGroupMessage, {
      errorText: errorText,
      helperText: helperText,
      msgId: msgId,
      theme: _theme
    }))
  );
};

export { Radio, RadioButton, RadioGroup };
